module.exports = __webpack_public_path__ + "img/enterra.41676c6d.jpg";